<div class="cards-container container-fluid">
    <div class="row g-3">
        <div class="col-sm-6 col-lg-2">
            <kpi-card [isLoading]="!accessRight" title="Statut" [body]="{ value: accessRight?.status }" cardClass="h-100"></kpi-card>
        </div>
        <div class="col-sm-6 col-lg-2">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Etat contractuel" [body]="{ value: technicalData?.etatContractuelCode }" cardClass="h-100"></kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Puissance souscrite (soutirage)" [body]="{value: technicalData?.puissanceSouscriteMaxValeur, 
                    suffix: ' '+technicalData?.puissanceSouscriteMaxUnite} " [footer]="{prefix: 'Max :', value: technicalData?.puissanceRaccordementSoutirageValeur, suffix: ' '+technicalData?.puissanceRaccordementSoutirageUnite}
                " cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Segment" [body]="{value: technicalData?.segmentCode }" [footer]="{value: ' '}" [descriptionContent]="technicalDataDefinition.segmentCode" cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-3">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Domaine de tension" [body]="{value:technicalData?.domaineTensionCode }" [footer]="{prefix: 'soit ', value: technicalData?.tensionLivraisonCode}" [descriptionContent]="technicalDataDefinition.domaineTensionCode" cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-2">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Type de compteur" [body]="{value:technicalData?.typeComptageCode }" [descriptionContent]="technicalDataDefinition.typeComptageCode" cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-5">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Plages heures pleines / heures creuses" [body]="{value:technicalData?.plageHeuresCreuses }" [footer]="{prefix: 'Future plage:', value: technicalData?.futuresPlagesHeuresCreuses }" [descriptionContent]="technicalDataDefinition.plageHeuresCreuses" cardClass="h-100">
            </kpi-card>
        </div>

        <div class="col-sm-6 col-lg-5">
            <kpi-card [error]="!isMeterActive" [isLoading]="isMeterActive && !technicalData" title="Formule tarifaire d'acheminement" [body]="{value:technicalData?.formuleTarifaireAcheminementCode }" [footer]="{prefix: 'Depuis le : ', value: technicalData?.dateDerniereModificationFormuleTarifaireAcheminement?.toLocaleDateString()}" [descriptionContent]="technicalDataDefinition.formuleTarifaireAcheminementCode" cardClass="h-100">
            </kpi-card>
        </div>
    </div>

    <br/>
    <div class="row g-3">
        <div class="col-sm-12">
            <h1>Localisation</h1>
        </div>
    </div>
    <div class="row  g-3">
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="adresse">Adresse</label>
                <ed-textfield innerId="adresse" type="text" [disabled]="true" [ngModel]="technicalData?.numeroEtNomVoie"></ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="detail">Détail</label>
                <ed-textfield innerId="detail" type="text" [disabled]="true" [ngModel]="technicalData?.escalierEtEtageEtAppartement"></ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="cp">Code postal</label>
                <ed-textfield innerId="cp" type="text" [disabled]="true" [ngModel]="technicalData?.codePostal"></ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="ci">Code Insee</label>
                <ed-textfield innerId="ci" type="text" [disabled]="true" [ngModel]="technicalData?.communeCode"></ed-textfield>
            </div>
        </div>
        <div class="col-sm-12">
            <geo-map-card title="Localisation" descriptionContent="Localisation approximative du point" descriptionTitle="Localisation" [geometries]="geometries ?? []" [isLoading]="geometries?.length == 0" [error]="!geometries" [getStyle]="getMapStyle" [legendConfig]="legendConfig"
                [mapId]="'locPRM'" [getTooltip]="getTooltip"></geo-map-card>


        </div>
    </div>

    <br/>
    <div class="row  g-3">
        <div class="col-sm-12">
            <h1>Droit d'accès</h1>
        </div>
    </div>
    <div class="row  g-3">
        <div class="col-sm-6" *ngIf="accessRight?.clientName">
            <div class="panel-row">
                <label for="clientName">Nom du client</label>
                <ed-textfield innerId="clientName" type="text" [disabled]="true" [ngModel]="accessRight?.clientName">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6" *ngIf="accessRight?.clientSirenSiret">
            <div class="panel-row">
                <label for="clientSirenSiret">SIRET du client</label>
                <ed-textfield innerId="clientSirenSiret" type="text" [disabled]="true" [ngModel]="accessRight?.clientSirenSiret">
                </ed-textfield>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="panel-row">
                <label for="clientRepresentativeName">Nom du représentant légal</label>
                <ed-textfield innerId="clientRepresentativeName" type="text" [disabled]="true" [ngModel]="accessRight?.clientRepresentativeName">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="clientRepresentativePhone">Téléphone du représentant légal</label
                    >
                    <ed-textfield
                        innerId="clientRepresentativePhone"
                        type="text"
                        [disabled]="true"
                        [ngModel]="accessRight?.clientRepresentativePhone">
                    </ed-textfield>
                </div>
            </div>
            <div class="col-sm-12">
                <div class="panel-row">
                    <label for="clientRepresentativeEmail">Email du représentant légal</label>
                <ed-textfield innerId="clientRepresentativeEmail" type="text" [disabled]="true" [ngModel]="accessRight?.clientRepresentativeEmail">
                </ed-textfield>
            </div>
        </div>

        <div class="col-sm-4">
            <div class="panel-row">
                <label for="createdAt">Créé le</label>
                <ed-textfield innerId="createdAt" type="text" [disabled]="true" [ngModel]="accessRight?.createdAt">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-4">
            <div class="panel-row">
                <label for="activatedAt">Actif depuis le</label>
                <ed-textfield innerId="activatedAt" type="text" [disabled]="true" [ngModel]="accessRight?.activatedAt">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-4" *ngIf="accessRight?.disabledAt">
            <div class="panel-row">
                <label for="disabledAt">Désactivé le</label>
                <ed-textfield innerId="disabledAt" type="text" [disabled]="true" [ngModel]="accessRight?.disabledAt">
                </ed-textfield>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="accessRight?.errorAt">
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="errorAt">Date de l'erreur</label>
                <ed-textfield innerId="errorAt" type="text" [disabled]="true" [ngModel]="accessRight?.errorAt">
                </ed-textfield>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="panel-row">
                <label for="errorMessage">Message d'erreur</label>
                <ed-textfield innerId="errorMessage" type="text" [disabled]="true" [ngModel]="accessRight?.errorMessage">
                </ed-textfield>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-4">
            <div class="panel-row">
                <label for="proofFile">Preuve de consentement : {{accessRight?.proofType}}</label>
                
                <ed-button
                    class="left px-1"
                    [colorSchema]="buttonColorsPrimary"
                    [icon]="'icon-download-cloud-02'"
                    (click)="downloadProofFile('userToConsumer')"
                    >Télécharger la preuve de consentement entre le titulaire et vous</ed-button>
                    <div class="row g-2" *ngIf="loggedUser?.isAdmin && accessRight?.proofType=='FILE'">
                        <div class="col-sm-6">
                            <div class="panel-row">
                                <label for="proofFile">Remplacer la preuve (Administrateur uniquement)</label>
                                <ed-input-file
                                innerId="fileProof"
                                [allowedFormat]="['PDF', 'PNG', 'JPG', 'JPEG']"
                                (onSubmit)="onFileUpload($event)"></ed-input-file>

                            </div>
                        </div>
                    </div>

                <ed-button
                    class="left px-1"
                    [colorSchema]="buttonColorsPrimary"
                    [icon]="'icon-download-cloud-02'"
                    (click)="downloadProofFile('userToThirdParty')"
                    >Télécharger la preuve de consentement entre Vous et consometer</ed-button>

            </div>
        </div>
    </div>

</div>